/**
* DevExpress Dashboard (_card-row.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { itemType } from '../../../metadata/_base-metadata';
export let vAlignment = { propertyName: 'vAlignment', modelName: '@VAlignment' };
export let indent = { propertyName: 'indent', modelName: '@Indent' };
export let cardRowBaseSerializationInfo = [vAlignment, indent, itemType];
export let elements = { propertyName: 'elements', modelName: 'CardRowElements', array: true };
export let cardRowSerializationInfo = cardRowBaseSerializationInfo.concat([elements]);
export let height = { propertyName: 'height', modelName: '@Height' };
export let cardSparklineRowOptions = { propertyName: 'sparklineOptions', modelName: 'sparklineOptions' };
export let cardSparklineRowSerializationInfo = cardRowBaseSerializationInfo.concat([height, cardSparklineRowOptions]);
